import { RoundChartElementHandler } from './round-chart.element-handler';

export class PieChartElementHandler extends RoundChartElementHandler<'chartPie'> {
  readonly type = 'chartPie';
}
